/**
 * Shared Instagram fetcher. Backend proxies to Behold.so and caches for 15 min,
 * so we can safely call from multiple components without worrying about rate limits.
 */
import { useEffect, useState } from 'react';

let _cache = null;
let _cachePromise = null;

async function fetchInstagram() {
  if (_cache) return _cache;
  if (_cachePromise) return _cachePromise;
  _cachePromise = fetch('/api/content/instagram')
    .then((r) => r.json())
    .then((d) => { _cache = d; return d; })
    .catch(() => ({ items: [], configured: false }));
  return _cachePromise;
}

export function useInstagram() {
  const [data, setData] = useState({ items: [], configured: true, loading: true });
  useEffect(() => {
    let alive = true;
    fetchInstagram().then((d) => { if (alive) setData({ ...d, loading: false }); });
    return () => { alive = false; };
  }, []);
  return data;
}
